export const locale = {
  lang: 'fr',
  data: {
    SHORTCUT: {
      CLICK_TO_ADD: 'Cliquez pour ajouter / supprimer un raccourci',
      SEARCH_FOR_A_PAGE: 'Rechercher une page',
      NO_SHORTCUTS_YET: 'Pas de raccourcis pour le moment !',
    },
  },
};
